enum CollectionNames {
  USERS = 'users',
  GROUPS = 'groups',
  AUDIT_LOGS = 'auditLogs',
  ROLES = 'roles',
  CHECKER_REQUESTS = 'checkerRequests',

  TRANSACTIONS = 'transactions',
  TRANSACTION_MODELS = 'transactionSchemas',
  DATA_STRUCTURES = 'dataStructures',
  STREAMS = 'streams',
  STREAM_MODELS = 'streamSchemas',
  RULES = 'rules',
  FLOW_LOGS = 'ruleLogs',
  FLOW_HISTORIES = 'ruleHistories',
  ACTION_TEMPLATES = 'actionTemplates',
  WATCHLIST_CONFIGURATION = 'watchlistGroups',

  TRACKERS = 'trackers',
  TRACKER_MODELS = 'trackerSchemas',

  CONNECTIONS = 'connections',
  CACHES = 'caches',
  ALARMS = 'cases',
  TENANTS = 'tenants',
  LISTS = 'lists',
  RULE_MODELS = 'ruleSchemas',
  CONNECTION_MODELS = 'connectionSchemas',
  LIST_MODELS = 'listSchemas',

  ENRICHMENTS = 'enrichments',
  ENRICHMENT_MODELS = 'enrichmentSchemas',

  CASE_SETTINGS = 'caseSettings',

  /*********** Category ******* */

  RULE_CATEGORIES = 'ruleCategories',
  TRANSACTION_CATEGORIES = 'transactionCategories',
  CONNECTION_CATEGORIES = 'connectionCategories',
  STRUCTURE_CATEGORIES = 'dataStructureCategories',
  ENRICHMENT_CATEGORIES = 'enrichmentCategories',
  LIST_CATEGORIES = 'listCategories',
  CASE_CONFIGURATION_CATEGORIES = 'caseConfigurationCategories',
  STREAM_CATEGORIES = 'streamCategories',
  ACTION_CATEGORIES = 'actionCategories',
  AI_MODEL_CATEGORIES = 'aiModelCategories',
  TRACKER_CATEGORIES = 'trackerCategories',
  CRA_CATEGORIES = "craCategories",

  COMPONENT_DEPENDENCY = 'componentDependency',

  ACTIONS = 'actions',
  ACTION_MODELS = 'actionSchemas',

  JOBS = 'backgroundJobs',

  NOTIFICATIONS = 'notifications',
  USER_SESSIONS = 'userSessions',

  /// -CHART
  CHARTS = 'charts',
  CHART_MODELS = 'chartSchemas',
  CHART_CATEGORIES = 'chartCategories',
  DASHBOARDS = 'dashboards',

  AI_MODELS = 'mlops',
  AI_MODELS_SCHEMA = 'mlopsSchemas',

  AI_RESULTS = 'mlopsResults',
  AI_METRICS = 'mlopsMetrics',

  USER_SYSTEM_ATTRIBUTES = "userSystemAttributes",

  // CRA
  CRA = "cra",
  CRA_SCHEMA = "cra_schema",
  CRA_STRING_SEGMENTS = "cra_string_segment",
  CRA_NUMBER_SEGMENTS = "cra_number_segment",
  CRA_DATE_SEGMENTS = "cra_date_segment",
  CRA_RESULT = "cra_result",
  ACH = "ach",

  MATCH_MANY_LOGS = "matchManyLogs"

}

export default CollectionNames;
